<template>
  <v-dialog v-model="show" width="786px" persistent>
    <!-- <template v-slot:activator="{ on }"> </template> -->
    <div class="modal">
      <v-card flat :loading="status_action === 'loading'">
        <v-row>
          <div class="icon-modal table-cell">
            <v-layout class="delete-warning-icon">
              <v-flex>
                <img :src="require('@/assets/img/warning.svg')" alt=""/>
              </v-flex>
            </v-layout>
          </div>
          <v-col class="table-cell modal-content">
            <div class="d-flex justify-space-between">
              <h6 class="modal-title mb-5" style="visibility: hidden">Delete User</h6>
            </div>

            <p>This homeowner will no longer have the ability to access KIEY.</p>

            <b>Are you sure you want to delete this homeowner?</b>

            <div class="mt-10 mb-10 buttons d-flex">
              <v-btn
                  class="mt-5 mr-6 btn-blanco few"
                  rounded
                  depressed
                  @click="delete_client"
                  :loading="status_action === 'loading'"
                  :disabled="status_action === 'loading'"
              >Yes
              </v-btn>
              <v-btn
                  class="mt-5 btn-azul few"
                  rounded
                  depressed
                  @click="hide"
                  :loading="status_action === 'loading'"
                  :disabled="status_action === 'loading'"
              >No
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  props: ['show', 'hide', 'selected'],
  data: () => ({
    image: require("@/assets/logo.svg")
  }),
  computed: {
    ...mapState({
      status_action: state => state.Users_list.status_action,
    })
  },
  components: {},
  methods: {
    ...mapActions({get_users: "Users_list/get_users"}),
    close: function () {
      this.hide();
    },
    setter() {
      const self = this;
      self.$emit("setter");
    },
    delete_client: function () {
      const self = this;
      self.$store.dispatch('Users_list/delete_client', self.selected).then(function (response) {
        if (response) {
          self.close();
          self.$store.dispatch("Users_list/clear_data", true);
          self.setter();
          self.get_users("client");
        }
      });
    }
  },
};
</script>
